import { DcmJsDatasetWrapper } from './dcmJsWrapper';
import { Modality, strToModality } from './modality';

export enum ObjectStatus {
    NEW = 'NEW', // object is new and not yet saved
    IMPORTED = 'IMPORTED', // object is imported from a DICOM source
    EXPORTED = 'EXPORTED', // object is exported to a DICOM source
}

export type GenerationModelDetails = {
    name: string;
    label: string;
    version?: string;
    isLatest?: boolean;
    customizationName?: string;
};

/* base for DICOM modality objects */
export abstract class DicomBase {
    /**
     * The {@link Modality} of the DICOM object.\
     * This specifies the type of data the DICOM object contains
     * (0008,0060) https://dicom.innolitics.com/ciods/ct-image/general-series/00080060
     */
    public modality: Modality;

    /**
     * sopInstanceUID is an unique identifier given to each individual DICOM object.\
     * Each sopInstanceUID only has to be unique within the single {@link Series}.\
     * And so every DICOM object within the same {@link Series} should have it's own unique sopInstanceUID.
     */
    public sopInstanceUID: string;

    public datasetWrapper: DcmJsDatasetWrapper;

    public objectStatus: ObjectStatus = ObjectStatus.NEW;

    public generationModel: GenerationModelDetails | undefined;

    public get isNew(): boolean {
        return this.objectStatus === ObjectStatus.NEW;
    }

    public get isExported(): boolean {
        return this.objectStatus === ObjectStatus.EXPORTED;
    }

    public get isImported(): boolean {
        return this.objectStatus === ObjectStatus.IMPORTED;
    }

    public setExported(): void {
        this.objectStatus = ObjectStatus.EXPORTED;
    }

    public setNew(): void {
        this.objectStatus = ObjectStatus.NEW;
    }

    public getAsDicomBlob(): Blob {
        return this.datasetWrapper.asBlob();
    }

    constructor(
        sopUid: string,
        modality: string,
        datasetWrapper: DcmJsDatasetWrapper
    ) {
        this.sopInstanceUID = sopUid;
        this.modality = strToModality(modality);
        this.datasetWrapper = datasetWrapper;
    }
}
